import { Fade } from "react-reveal";

export default function CardPageSin({ children }) {
  return (
    <Fade>
      <div className="card__contenido_sin">{children}</div>
    </Fade>
  );
}
